import { Link } from "react-router-dom"

import OccasionGrid from "components/occasion-grid"
import Button from "components/ui/button"
import Divider from "components/ui/divider"
import { jewlr_t, IS_GE_CHECKOUT } from "helpers/application"

const EmptyCart = () => {
  const is_ge_checkout = IS_GE_CHECKOUT()

  return (
    <>
      <div className="contained tablet:mt-32 mt-10 flex flex-col px-16">
        <h1 className="h2 tablet:mb-24">
          My {jewlr_t("terms.Cart")} (0<span className="sr-only"> Items</span>)
        </h1>
        <Divider className="tablet:hidden my-24" />
        <p className="body-lg text-center" data-cy="cart-empty-msg">
          Your {jewlr_t("terms.cart")} is currently empty.
        </p>
        <Button
          asChild
          className="tablet:inline-flex mx-auto mt-16 hidden font-semibold"
          variant="primary"
        >
          <Link data-lc="empty-cart" to="/">
            Shop all products
          </Link>
        </Button>
      </div>
      <OccasionGrid />
      <div className="tablet:hidden px-16 pb-32">
        <Button asChild className="w-full font-semibold" variant="primary">
          <Link data-lc="empty-cart" to="/">
            Shop all products
          </Link>
        </Button>
        <ul className="body mt-12 flex list-none items-center justify-center gap-4 text-center font-medium [&_li]:flex [&_li]:items-center [&_li]:after:ml-4 [&_li]:after:inline-block [&_li]:after:h-14 [&_li]:after:w-px [&_li]:after:bg-black [&_li]:last:after:hidden">
          <li>Free {jewlr_t("terms.shipping")} on all orders</li>
          <li>{is_ge_checkout ? "30" : "99"}-day returns</li>
        </ul>
      </div>
    </>
  )
}

export default EmptyCart
